var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "video-chapter" },
    [
      _vm._t("default"),
      _vm._v(" "),
      _c("h1", { staticClass: "video-chapter-title" }, [
        _vm._v(_vm._s(_vm.chapter.name)),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "video-player-wrap" }, [
        _vm.videoSource.type === "embed"
          ? _c("div", {
              ref: "player",
              attrs: {
                "data-plyr-provider": _vm.videoSource.provider,
                "data-plyr-embed-id": _vm.videoSource.id,
              },
            })
          : _c("video", {
              ref: "player",
              attrs: { playsinline: "", controls: "" },
            }),
      ]),
      _vm._v(" "),
      _vm.chapter.description
        ? _c("p", { staticClass: "video-chapter-description" }, [
            _vm._v(_vm._s(_vm.chapter.description)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "article-complete-card" }, [
        _c(
          "a",
          {
            staticClass: "btn primary-btn",
            on: {
              click: function ($event) {
                return _vm.$router.push({
                  name: "categoryDashboard",
                  params: { category: _vm.$route.params.category },
                })
              },
            },
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("ARTICLE_COMPLETE_BACK_BUTTON")) +
                "\n        "
            ),
          ]
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }